// src/app/category/[id]/page.jsx

import CategoryClient from "./CategoryClient";

// ✅ ADD THIS FUNCTION
export async function generateStaticParams() {
  try {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/categories`, {
      headers: { Accept: "application/json" },
      cache: "force-cache",
    });

    const json = await res.json();
    const categories = json.data || [];

    // Return array of all category IDs
    return categories.map((category) => ({
      id: String(category.id), // or category.slug if you're using slugs
    }));
  } catch (e) {
    console.error("Failed to generate static params:", e);
    // Return empty array as fallback
    return [];
  }
}

export default async function CategoryPage({ params }) {
  const { id } = await params; // ✅ MUST await
  let categories = [];
  
  try {
    const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/categories`, {
      headers: { Accept: "application/json" },
      cache: "force-cache",
    });

    const json = await res.json();
    categories = json.data || [];
  } catch (e) {
    console.error("Category fetch failed:", e);
  }

  return (
    <CategoryClient
      categoryId={String(id)}
      categories={categories}
    />
  );
}